import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ImagesRotator from '../../2_Molecules/ImagesRotator/ImagesRotator'
import Image360 from '../../2_Molecules/Image360/Image360'
import { Svg } from '../../1_Atoms/Svg/Svg'
import IconText from '../../1_Atoms/IconText/IconText'
import { languageController } from '../../../controllers/language/languageController'

function ThreeSixtyViewer({
  exteriorImages,
  interiorPanoramaImage
}) {
  const [isExterior, setIsExterior] = useState(true)

  return (
    <div className="mz-360-viewer">

      <div className="mz-360-viewer__content">
        <ImagesRotator images={exteriorImages} className="mz-360-viewer__exterior" aria-hidden={!isExterior} />
        <Image360 image={interiorPanoramaImage} className="mz-360-viewer__interior" aria-hidden={isExterior} />
      </div>

      <div className="mz-360-viewer__tool">
        <IconText
          label={<><span>{languageController.getCopy('global', 'drag360')}</span> 360°</>}
          iconType="threesixty"
          iconColour="grey"
          iconSize={1.3}
          iconTop="2px"
          className="mz-360-viewer__tool-drag"
        />
        <button
          className="interactive mz-icon-text reset mz-360-viewer__tool-switch"
          onClick={() => setIsExterior(!isExterior)}
        >
          <Svg type={isExterior ? 'steeringwheel' : 'carexterior'} colour="grey" size={1.5} />
          {/* TODO: May update this when FR copy is ready. */}
          <div className="mz-icon-text-text">{isExterior ? 'Interior' : 'Exterior'} <span>view</span></div>
        </button>
      </div>

    </div>
  )
}

ThreeSixtyViewer.propTypes = {
  exteriorImages: PropTypes.array.isRequired,
  interiorPanoramaImage: PropTypes.string.isRequired,
}

export default ThreeSixtyViewer

